import {Component, Vue} from "vue-property-decorator";

@Component
export class Columns extends Vue {
  render(){
    return <div class="columns">{this.$slots.default}</div>;
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0b0dee80/columns.tsx" });